"use client";

import dynamic from "next/dynamic";

// Client boundary so dynamic() code-splits PluginInfo out of the shared bundle.
// See SubscribeButtonLazy for the reasoning.
export default dynamic(() => import("../FeaturedPlugin/components/PluginInfo"));
